import ViewBase from '../../views/view-base.view';
import { staticUrls } from '../../config/constants';
import 'CssFolder/components/image-carousel.scss';

export default function ImageCarouselComponent() {
  ViewBase.call(this);

  let _files = [];
  let _selectedFileId;

  return {
    oninit: (vnode) => {
      if (vnode.attrs.files) {
        _files = vnode.attrs.files;
      }

      if (vnode.attrs.selectedFileId) {
        _selectedFileId = vnode.attrs.selectedFileId;
      }
    },
    view: ({ attrs }) => {
      return m('#imageGallery.carousel.slide.scs-image-carousel',
        m('.carousel-inner',
          _files.map(file => {
            return m('.carousel-item' + (_selectedFileId == file.id ? '.active' : ''), { "style": "height: 500px;" },
              m('img.d-block', { src: file.src && file.src.length > 0 ? file.src : staticUrls.imageUnavailable, "style": "max-height: 100%; max-width: 100%; margin: auto;" }),
            );
          })
        ),
        m('button[type="button"].carousel-control-prev', { "data-bs-target": "#imageGallery", "data-bs-slide": "prev" },
          m('span.fs-1.text-primary', { "aria-hidden": "true" }, m("i.bi.bi-arrow-left-circle-fill")),
          m('span.visually-hidden', "Previous")
        ),
        m('button[type="button"].carousel-control-next', { "data-bs-target": "#imageGallery", "data-bs-slide": "next" },
          m('span.fs-1.text-primary', { "aria-hidden": "true" }, m("i.bi.bi-arrow-right-circle-fill")),
          m('span.visually-hidden', "Next")
        )
      );
    }
  }
}
